/**
 *
 * /DeleteButton
 *
 */

import React, { useState } from 'react'

// NPM Libraries
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Components
import OnClickOutside from 'components/OnClickOutside'
import { COLORS } from 'global-styles'

const MainButton = styled.button`
	display: flex !important;
	align-items: center;
	outline: none;

	& > .default-hover-button {
		width: 30px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		border-radius: 50px;

		&:hover {
			background-color: ${COLORS.borderGrey};
		}
	}
`

function DeleteButton({
	onDelete,
	children,
	message,
	deleting,
	loading_message,
	hidden,
	with_hover = false,
	disabled,
	style = {},
}) {
	const [clicked_at, setClickedAt] = useState(null)
	const [cancel_timer, setCancelTimer] = useState(null)
	const deleting_message = loading_message || '- Deleting'

	return (
		<OnClickOutside handleClickOutside={() => clicked_at && setClickedAt(null)}>
			<MainButton
				type="button"
				className="btn-unstyled text-right text-danger d-inline-block"
				onClick={() => {
					if (clicked_at) {
						if (cancel_timer) {
							clearTimeout(cancel_timer)
						}
						if (clicked_at && new Date() - clicked_at > 200) {
							// enforces brief wait between clicks
							onDelete()
						}
					} else {
						setClickedAt(new Date())
					}
				}}
				onMouseLeave={() => {
					if (cancel_timer) {
						clearTimeout(cancel_timer)
					}
					setCancelTimer(
						setTimeout(() => {
							setClickedAt(null)
						}, 2000),
					)
				}}
				style={{ opacity: hidden ? 0 : 1, ...style }}
				disabled={disabled}
			>
				{children ? (
					<React.Fragment>{children}</React.Fragment>
				) : (
					<React.Fragment>
						{with_hover ? (
							<div className="default-hover-button">
								<FontAwesomeIcon icon="trash" />
							</div>
						) : (
							<FontAwesomeIcon icon="trash" />
						)}
					</React.Fragment>
				)}
				<span
					style={{
						maxWidth: clicked_at ? '400px' : 0,
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						display: 'inline-block',
						transition: 'all 0.3s ease-in-out',
						verticalAlign: 'bottom',
						marginLeft: with_hover ? '0' : '.5rem',
					}}
				>
					{deleting ? deleting_message : message || ' Really Delete?'}
				</span>
			</MainButton>
		</OnClickOutside>
	)
}

DeleteButton.propTypes = {
	message: PropTypes.string,
	onDelete: PropTypes.func.isRequired,
	hidden: PropTypes.bool,
	deleting: PropTypes.bool,
	disabled: PropTypes.bool,
	loading_message: PropTypes.string,
	with_hover: PropTypes.bool,
	children: PropTypes.element,
	style: PropTypes.object,
}

export default DeleteButton
